__turbopack_context__.v({
  "active": "WorkLifeToggle-module__dVZ9bG__active" + " " + "WorkLifeToggle-module__dVZ9bG__link",
  "link": "WorkLifeToggle-module__dVZ9bG__link",
  "sep": "WorkLifeToggle-module__dVZ9bG__sep",
  "switch": "WorkLifeToggle-module__dVZ9bG__switch",
});
